import { __assign, __rest } from "tslib";
import React from 'react';
import VeltVideoPlayerControlsWireframe from './VeltVideoPlayerControlsWireframe/VeltVideoPlayerControlsWireframe';
import VeltVideoPlayerCopyLinkWireframe from './VeltVideoPlayerCopyLinkWireframe/VeltVideoPlayerCopyLinkWireframe';
import VeltVideoPlayerDisplayWireframe from './VeltVideoPlayerDisplayWireframe/VeltVideoPlayerDisplayWireframe';
import VeltVideoPlayerMinimizeButtonWireframe from './VeltVideoPlayerMinimizeButtonWireframe/VeltVideoPlayerMinimizeButtonWireframe';
import VeltVideoPlayerPanelWireframe from './VeltVideoPlayerPanelWireframe/VeltVideoPlayerPanelWireframe';
import VeltVideoPlayerSubtitlesWireframe from './VeltVideoPlayerSubtitlesWireframe/VeltVideoPlayerSubtitlesWireframe';
import VeltVideoPlayerTranscriptionWireframe from './VeltVideoPlayerTranscriptionWireframe/VeltVideoPlayerTranscriptionWireframe';
import { transformWireframeProps } from '../../utils/propUtils';
var VeltVideoPlayerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerWireframe.Controls = VeltVideoPlayerControlsWireframe;
VeltVideoPlayerWireframe.CopyLink = VeltVideoPlayerCopyLinkWireframe;
VeltVideoPlayerWireframe.Display = VeltVideoPlayerDisplayWireframe;
VeltVideoPlayerWireframe.MinimizeButton = VeltVideoPlayerMinimizeButtonWireframe;
VeltVideoPlayerWireframe.Panel = VeltVideoPlayerPanelWireframe;
VeltVideoPlayerWireframe.Subtitles = VeltVideoPlayerSubtitlesWireframe;
VeltVideoPlayerWireframe.Transcription = VeltVideoPlayerTranscriptionWireframe;
export default VeltVideoPlayerWireframe;
